/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The different types of counters in the Stammdaten module
 */
export enum EnumStammdatenCounterTypes {
    /**
     * Counter type for addresses
     */
    Address = 0,
    /**
     * Counter type for services
     */
    Service = 1,
    /**
     * Counter type for debtors
     */
    Debtor = 2,
    /**
     * Counter type for creditors
     */
    Creditor = 3,
}
